import Catalyst from '@Services/Catalyst';

export const trackAdobeAnalyticsError = (formError) => {
  if (formError) {
    Catalyst.trackError(
      {
        message: formError,
        component: 'History',
      },
      'fe-'
    );
  }
};

export const trackAdobeAnalyticsPage = (route) => {
  Catalyst.trackPage(route);
};

export const trackConversionDriverClick = () => {
  Catalyst.trackConversionDriverClick('history:savesearch:sign-in');
};

export const trackHistoryDeleteButtonClick = (page) => {
  const normalizedPage = page?.toLowerCase();

  if (!['recent', 'saved'].includes(normalizedPage)) {
    return;
  }

  Catalyst.trackEvent('buttonClick', {
    buttonType: `rx2:history-${normalizedPage}:type=button:name=delete`,
  });
};

const historyMiniSearchTypeByPage = {
  recent: 'rx2:recent-history:mini-search',
  saved: 'rx2:saved-history:mini-search',
};

const normalizeHistoryContext = (context) => {
  const normalizedContext = String(context || '')
    .replace(/"/g, '')
    .trim()
    .toLowerCase();
  return normalizedContext;
};

const getHistoryMiniSearchType = (page, context) => {
  const normalizedPage = page?.toLowerCase();
  const baseType = historyMiniSearchTypeByPage[normalizedPage];

  if (!baseType) {
    return '';
  }

  const normalizedContext = normalizeHistoryContext(context);
  return normalizedContext ? `${baseType}:explicit:${normalizedContext}` : baseType;
};

const normalizeFacets = (facets) => {
  if (!Array.isArray(facets)) {
    return [];
  }

  return facets
    .filter((facet) => facet?.name)
    .map((facet) => ({
      name: String(facet.name),
      values: Array.isArray(facet.values) ? facet.values.map((value) => String(value)) : [],
    }));
};

export const trackHistoryMiniSearchStart = (page) => {
  const type = getHistoryMiniSearchType(page);
  if (!type) {
    return;
  }

  Catalyst.trackEvent('searchStart', {
    search: {
      type,
    },
  });
};

export const trackHistoryMiniSearchResultsUpdated = ({
  page,
  criteria,
  totalResults,
  currentPage,
  resultsPerPage,
  sortType,
  context,
  facets,
}) => {
  const type = getHistoryMiniSearchType(page, context);
  if (!type) {
    return;
  }

  Catalyst.trackEvent('searchResultsUpdated', {
    search: {
      criteria,
      totalResults: String(totalResults),
      currentPage: String(currentPage),
      resultsPerPage: String(resultsPerPage),
      sortType,
      type,
      facets: normalizeFacets(facets),
    },
  });
};

export const trackHistoryViewSearchButtonClick = (page) => {
  const normalizedPage = page?.toLowerCase();

  if (normalizedPage === 'recent') {
    Catalyst.trackEvent('buttonClick', {
      buttonType: 'rx2:history-recent:type=button:name=rerun',
    });
    return;
  }

  if (normalizedPage === 'saved') {
    Catalyst.trackEvent('buttonClick', {
      buttonType: 'rx2:history-saved:type=pencil:name=view-search',
    });
  }
};

export const trackHistoryEditQueryButtonClick = (page) => {
  const normalizedPage = page?.toLowerCase();

  if (normalizedPage === 'recent') {
    Catalyst.trackEvent('buttonClick', {
      buttonType: 'rx2:history-recent:type=pencil:name=edit-query',
    });
    return;
  }

  if (normalizedPage === 'saved') {
    Catalyst.trackEvent('buttonClick', {
      buttonType: 'rx2:history-saved:type=pencil:name=edit-query',
    });
  }
};

export const trackHistoryCreateAlertButtonClick = (page) => {
  const normalizedPage = page?.toLowerCase();

  if (normalizedPage === 'recent') {
    Catalyst.trackEvent('buttonClick', {
      buttonType: 'rx2:history-recent:type=button:name=create-alert',
    });
    return;
  }

  if (normalizedPage === 'saved') {
    Catalyst.trackEvent('buttonClick', {
      buttonType: 'rx2:history-saved:type=button:name=create-alert',
    });
  }
};

export const trackHistorySaveQueryButtonClick = (page) => {
  if (page?.toLowerCase() !== 'recent') {
    return;
  }

  Catalyst.trackEvent('buttonClick', {
    buttonType: 'rx2:history-recent:type=button:name=save',
  });
};

export const trackHistoryEditNameButtonClick = () => {
  Catalyst.trackEvent('buttonClick', {
    buttonType: 'rx2:history-saved:type=pencil:name=edit-name',
  });
};

export const trackHistoryBannerInformationCloseButtonClick = () => {
  Catalyst.trackEvent('buttonClick', {
    buttonType: 'rx2:history:type=button:name=banner-information-close',
  });
};

export const trackHistoryPopupSaveSearchButtonClick = () => {
  Catalyst.trackEvent('buttonClick', {
    buttonType: 'rx2:history:type=button:name=popup-save-search',
  });
};
